import CheckIcon from './CheckIcon'

export default CheckIcon
